<template>
  <permissions-expansion-panel
    :header="header"
    :items="items"
    :level="level + 1"
    @updatePermissionsValue="updatePermissionsValue"
    @updateAttachmentsCommentsValue="updateAttachmentsCommentsValue"
  >
    <template #content>
      <v-list dense class="pt-0" :style="{ 'background-color': level === 1 ? '#f7f7f7' : 'white' }">
        <template v-for="item in items">
          <users-groups-permissions-dialog-layers-item
            v-if="item.type === 'features_layer' || item.type === 'service_layer'"
            :key="item.name"
            v-bind="item"
            group="layers"
            :level="level"
          >
          </users-groups-permissions-dialog-layers-item>
          <v-list-item v-else :key="item.label">
            <v-expansion-panels accordion multiple class="elevation-0 panels">
              <permissions-expansion-panel-layers
                :header="item.name"
                :items="[...item.layers, ...item.subgroups]"
                :level="level + 1"
              >
              </permissions-expansion-panel-layers>
            </v-expansion-panels>
          </v-list-item>
        </template>
      </v-list>
    </template>
  </permissions-expansion-panel>
</template>

<script>
import PermissionsExpansionPanel from '@/components/PermissionsExpansionPanel';
import UsersGroupsPermissionsDialogLayersItem from '@/components/UsersGroupsPermissionsDialogLayersItem';

export default {
  name: 'PermissionsExpansionPanelLayers',
  components: {
    PermissionsExpansionPanel,
    UsersGroupsPermissionsDialogLayersItem,
  },
  props: {
    level: {
      type: Number,
      required: true,
    },
    header: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  methods: {
    updateAttachmentsCommentsValue(value) {
      const featuresLayers = this.items.filter(item => item.type === 'features_layer');
      for (const item of featuresLayers) {
        this.$store.set('users/SET_CURRENT_GROUP_PERMISSIONS_VALUE!', {
          group: 'layers',
          id: item.id,
          valueKey: 'attachments_and_comments_value',
          value,
        });
      }
    },
    updatePermissionsValue(value) {
      const featuresLayers = this.items.filter(item => item.type === 'features_layer');
      const servicesLayers = this.items.filter(item => item.type !== 'features_layer');

      for (const item of featuresLayers) {
        this.$store.set('users/SET_CURRENT_GROUP_PERMISSIONS_VALUE!', {
          group: 'layers',
          id: item.id,
          valueKey: 'main_value',
          value,
        });
      }
      for (const item of servicesLayers) {
        this.$store.set('users/SET_CURRENT_GROUP_PERMISSIONS_VALUE!', {
          group: 'layers',
          id: item.id,
          valueKey: 'main_value',
          value: value === 2 ? 1 : value,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-expansion-panels {
  border-radius: 0;
}
.v-expansion-panel {
  ::before {
    box-shadow: none;
  }

  @include border(top);
  @include border(right);
  @include border(left);
  &:last-child {
    @include border(bottom);
  }
}
</style>
